import { createContext } from "react";

export interface PlanetContextType {
    cmsPlanetId: undefined | string;
    alphabet: undefined | string[];
}

export const planetContext = createContext<null | PlanetContextType>(null);